<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/BDtpJ3/tc-custom/9781452181639.jpg?1705294765607" alt="This image is the cover for the book Disco Cube Cocktails"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Disco Cube Cocktails
      </h1>
      <p class="bookDescription body article font2">
        <b>Wow drinkers everywhere with this ’</b><b>70s-inspired book based on the magical properties of ice from decorative to taste-transforming cubes—playlists included.</b><br/>  <br/> With 100+ recipes for artful ice and the drinks that go with them, home bartenders can learn new icy creations to elevate any classic drink, infuse new flavor into a sipper as the ice melts, or impress friends at a party with a frosty punch bowl.<br/>  <br/> While traveling as a DJ, Leslie Kirchhoff fell in love with the art of craft cocktails, but noticed one thing was missing: inventive ice. Taking it upon herself to create something truly unique, she started Disco Cubes as a passion project to explore the art of ice. Now you can do the same at home with recipes that offer more than just a classic cube.<br/>  <br/> In this not-so-classic cocktail book, there are one-ingredient cubes to elevate any drink, infused ice to add flavor to simple cocktails, and perfect pairings where ice and drink come together to make a concoction that you (and your guests) won’t forget. Plus, you’ll find playlists at the beginning of each chapter, to set the mood for any occasion.<br/>  <br/> Recipes include innovative sips such as:   Rose Cubes in a White Negroni  Jalapeño ice for an evolving margarita  A Golden Bloody Mary that shifts from sweet to savory as the ice melts   The Walter Gibbons with a Red Onion Raft  White peach spheres for a cool take on a classic Bellini   A great gift for cocktail and bartending enthusiasts, home cocktail makers and entertainers, drink-nerds who love cocktail history, and anyone who enjoys experimentation. 
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Leslie Kirchhoff
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Chronicle Books LLC
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4f35ebba